import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { authQueryOptions } from "@/services/auth/auth.options";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/$orgId",
)({
	beforeLoad: async ({ context, params }) => {
		const viewOrgInfoQuery = context.queryClient.ensureQueryData(
			authQueryOptions.checkAction({
				name: "ViewOrganizationInfo",
				entityType: null,
				entityId: params.orgId,
			}),
		);

		if (!viewOrgInfoQuery) {
			throw redirect({ to: "/unauthorized" });
		}
	},
	component: WebAppDashboard,
});

function WebAppDashboard() {
	const { orgId } = Route.useParams();
	const { t } = useAppTranslation();
	void orgId;
	void t;

	return <Outlet />;
}
